<template>
  <div class="user-know">
    <div class="title">知心慧学软件使用协议</div>
    <div>
      <div class="title">法律声明</div>
      <p>
        凡访问、浏览或使用江西风向标智能科技有限公司（以下简称“风向标”）出品的“知心慧学平台”产品（包括知心慧学平台网页端、H5、手机APP、微信公众号、小程序等，以下统称“知心慧学”），表明您已阅读、理解并同意接受以下条款的约束，并遵守所有适用的法律和法规。您一旦使用知心慧学，则须秉持诚信的原则遵守以下条款。
      </p>
    </div>
    <div>
      <div class="title">一般原则</div>
      <p>
        以下规则适用于所有知心慧学产品用户或浏览者，因业务调整，可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被知心慧学中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。
      </p>
    </div>

    <div>
      <div class="title">权益说明</div>
      <div>
        <p>
          风向标对其发行的或与合作公司共同发行的包括但不限于提供的软件及相关产品或服务的全部内容，享有知识产权，受法律保护。如果相关内容未含权利声明，并不代表风向标对其不享有权利和不主张权利，您应根据法律、法规及诚信原则尊重权利人的合法权益并合法使用该内容。</p>
        <p>
          未经风向标书面同意，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息、文字的任何部分进行使用、复制、修改、抄录、传播或与其他产品捆绑使用、销售，或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印
          （未作修改，且须保留该内容中的版权说明或其他所有权的说明）除外。</p>
        <p>
          上述软件中使用和显示的商标和标识（以下统称“商标”）是风向标及其关联公司在教育及其他相关领域内注册和未注册的有关商标，受法律保护，该等软件中所载的任何内容，未经风向标书面许可，任何人不得以任何方式使用风向标、知心慧学及近似名称和相关商标、标识。</p>
      </div>
    </div>

    <div>
      <div class="title">用户信息</div>
      <p>
        <span class="impress">为知心慧学提供相应服务之必须，您需要仔细阅读《知心慧学学生端使用许可app&知心慧学学生端隐私政策》，并授权风向标按照《知心慧学学生端使用许可app&知心慧学学生端隐私政策》的约定采集、使用您的个人信息。同时，为能更好的给您提供服务，以最便利、最全面地实现您的多方位需求，知心慧学与其合作网络服务平台提供互补性服务，为实现该服务功能的正常运行，知心慧学与合作平台在用户同意的情况下将共享必要的用户信息。知心慧学对于共享用户实行相同的信息安全和用户隐私政策，并监督合作网络服务平台遵守不低于知心慧学信息安全和用户隐私政策标准的安全和隐私政策。</span>
      </p>
    </div>

    <div>
      <div class="title">责任限制声明</div>
      <div>
        <p class="impress">
          不论在何种情况下，风向标由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。
        </p>
        <p class="impress">
          无论在任何情况下（包括但不限于疏忽原因），由于使用知心慧学上的信息或由知心慧学链接的信息，或其他与知心慧学链接的网站信息，对您或他人所造成任何的损失或损害（包括直接、简介、特别或后果性的损失或损害，例如收入或利润之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）。
        </p>
        <p class="impress">
          知心慧学所载的信息，包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确和详尽，但风向标并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。风向标表明不对这些信息和内容作出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智能终端病毒的保证。
        </p>
        <p class="impress">
          对于知心慧学上所提及或展示的非风向标产品或服务，风向标仅提供基本信息。风向标不是相关产品的生产者或经销者，亦不是服务的提供方。风向标不就知心慧学上所提及或展示的非风向标产品或服务做出任何声明或保证，所有展示的产品和服务应受其本公司或服务提供方所做质量承诺和条款的约束。</p>
      </div>
    </div>

    <div>
      <div class="title">知心慧学服务</div>
      <p>
        知心慧学为在校学生提供定制教学辅助，充分利用互联网、大数据和人工智能技术，通过系统对学生课业成绩进行数据分析、数据测评、错题提炼，为学生制定精准学习计划和方案，通过全学习过程数据的分析、知识和能力结构的建模、学习问题的诊断和分析、学科优势的发现和增强，助推精准教学改革。
        知心慧学由江西风向标智能科技有限公司提供内容服务和数据分析服务。</p>
    </div>

    <div>
      <div class="title">第三方链接及服务</div>
      <p>
        知心慧学可能保留有第三方网站或网址的链接及第三方服务，是否访问这些链接或接受相应服务将由用户自己做出决定，风向标并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。风向标没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何法律责任。如果您决定访问任何与本平台链接的第三方网站，其可能带来的结果和风险全部由您自己承担。</p>
    </div>

    <div>
      <div class="title">适用法律和管辖权</div>
      <p>
        通过访问知心慧学使用风向标提供的或其合作服务提供商提供的服务，即表示您同意该访问或服务受中华人民共和国法律的约束，且您同意受中华人民共和国法院的管辖。访问或接受服务过程中发生的争议应当协商解决，协商不成的，由实际服务提供者或实际网络信息服务提供者住所地有管辖权的法院诉讼解决。</p>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style lang="less" scoped>
  .user-know {
    .title {
      text-align: center;
      color: #333;
      font-weight: bold;
    }

    div {
      .title {
        text-align: left;
      }
    }

    padding: 0.2rem 0.4rem;
    font-size: 0.36rem;
    line-height: 0.6rem;
    text-align: justify;

    .blue {
      text-decoration: underline;
      color: blue;
    }

    .impress {
      text-decoration: underline;
      color: #333333;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// Agreement.vue?b39a4346